/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideStandingItem } from './OverrideStandingItem';
import {
    OverrideStandingItemFromJSON,
    OverrideStandingItemFromJSONTyped,
    OverrideStandingItemToJSON,
    OverrideStandingItemToJSONTyped,
} from './OverrideStandingItem';

/**
 * 
 * @export
 * @interface DistributePrizesBody
 */
export interface DistributePrizesBody {
    /**
     * Override final standings if needed
     * @type {Array<OverrideStandingItem>}
     * @memberof DistributePrizesBody
     */
    overrideStandings?: Array<OverrideStandingItem>;
    /**
     * Preview payouts without actually distributing
     * @type {boolean}
     * @memberof DistributePrizesBody
     */
    dryRun?: boolean;
    /**
     * Bypass idempotency. Required to redistribute on top of an existing payout. Use with caution — double-spend risk.
     * @type {boolean}
     * @memberof DistributePrizesBody
     */
    forceRedistribute?: boolean;
}

/**
 * Check if a given object implements the DistributePrizesBody interface.
 */
export function instanceOfDistributePrizesBody(value: object): value is DistributePrizesBody {
    return true;
}

export function DistributePrizesBodyFromJSON(json: any): DistributePrizesBody {
    return DistributePrizesBodyFromJSONTyped(json, false);
}

export function DistributePrizesBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributePrizesBody {
    if (json == null) {
        return json;
    }
    return {
        
        'overrideStandings': json['overrideStandings'] == null ? undefined : ((json['overrideStandings'] as Array<any>).map(OverrideStandingItemFromJSON)),
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
        'forceRedistribute': json['forceRedistribute'] == null ? undefined : json['forceRedistribute'],
    };
}

export function DistributePrizesBodyToJSON(json: any): DistributePrizesBody {
    return DistributePrizesBodyToJSONTyped(json, false);
}

export function DistributePrizesBodyToJSONTyped(value?: DistributePrizesBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overrideStandings': value['overrideStandings'] == null ? undefined : ((value['overrideStandings'] as Array<any>).map(OverrideStandingItemToJSON)),
        'dryRun': value['dryRun'],
        'forceRedistribute': value['forceRedistribute'],
    };
}

